import { type VariantProps, cva } from 'class-variance-authority'
import React from 'react'

import { cn } from '../../lib/utils'

const headlineVariants = cva('text-foreground', {
  variants: {
    as: {
      h1: 'font-medium text-[36px]',
      h2: 'font-medium text-[26px]',
      h3: 'font-medium text-[20px]'
    },
    font: {
      sans: 'font-sans',
      mono: 'font-mono'
    }
  },
  compoundVariants: [
    {
      font: 'mono',
      as: 'h1',
      class: 'text-[38px]'
    },
    {
      font: 'mono',
      as: 'h3',
      class: 'font-normal'
    }
  ],
  defaultVariants: {
    font: 'sans'
  }
})

export interface HeadlineProps
  extends React.ButtonHTMLAttributes<HTMLHeadElement>,
    VariantProps<typeof headlineVariants> {}

const Headline = React.forwardRef<HTMLHeadingElement, HeadlineProps>(
  ({ children, className, as = 'h1', font, ...props }, ref) => {
    let Tag = as
    return (
      <Tag
        className={cn(headlineVariants({ as, font, className }))}
        ref={ref}
        {...props}>
        {children}
      </Tag>
    )
  }
)
Headline.displayName = 'Headline'

export default Headline
